export default __webpack_public_path__ + "static/media/p18.3394229b.jpg";